import {SortOption, SortProperty} from '../interfaces';

/** Ключ localStorage для «Запомнить выбор» сортировки результатов поиска */
export const SEARCH_SORT_STORAGE_KEY = 'search-results-sort-preference';

export type SortPreset = {
    label: string;
    property: SortProperty;
    direction: 'asc' | 'desc';
};

/** Пункты попапа настроек сортировки (десктоп); порядок = порядок в UI */
export const SORT_SETTINGS_POPUP_PRESETS: SortPreset[] = [
    {label: 'Дешевле', property: SortProperty.Price, direction: 'asc'},
    {label: 'Дороже', property: SortProperty.Price, direction: 'desc'},
    {label: 'Срок короче', property: SortProperty.DeliveryDays, direction: 'asc'},
    {label: 'Срок дольше', property: SortProperty.DeliveryDays, direction: 'desc'},
    {label: 'Высокий рейтинг', property: SortProperty.Rating, direction: 'desc'},
    {label: 'Низкий рейтинг', property: SortProperty.Rating, direction: 'asc'},
    {label: 'Дата поставки раньше', property: SortProperty.DeliveryDate, direction: 'asc'},
    {label: 'Дата поставки позже', property: SortProperty.DeliveryDate, direction: 'desc'}
];

/** Те же правила, что в SectionItemsHeader.handleSortChanged / MobileSorting */
export function applySortPreset(
    sortOptions: SortOption[],
    property: SortProperty,
    direction: 'asc' | 'desc'
): SortOption[] {
    return sortOptions.map((x) =>
        x.property !== property
            ? {...x, direction: 'asc', isActive: false}
            : {...x, direction, isActive: true}
    ) as SortOption[];
}

export function isDefaultSearchSort(sortOptions: SortOption[]): boolean {
    const active = sortOptions.find((o) => o.isActive);
    return (
        active !== undefined && active.property === SortProperty.Price && active.direction === 'asc'
    );
}

export function readSearchSortPreference(): {
    property: SortProperty;
    direction: 'asc' | 'desc';
} | null {
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem(SEARCH_SORT_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as {property?: number; direction?: string};
        if (
            typeof parsed.property !== 'number' ||
            parsed.property < SortProperty.Rating ||
            parsed.property > SortProperty.Price
        ) {
            return null;
        }
        if (parsed.direction !== 'asc' && parsed.direction !== 'desc') return null;
        return {property: parsed.property as SortProperty, direction: parsed.direction};
    } catch {
        return null;
    }
}

export function writeSearchSortPreference(sortOptions: SortOption[]): void {
    if (typeof window === 'undefined') return;
    const active = sortOptions.find((o) => o.isActive);
    if (!active) return;
    try {
        window.localStorage.setItem(
            SEARCH_SORT_STORAGE_KEY,
            JSON.stringify({property: active.property, direction: active.direction})
        );
    } catch {
        // ignore quota / private mode
    }
}

export const SORT_CONFIG = [
    {
        label: 'Дешевле',
        property: SortProperty.Price,
        direction: 'asc' as const
    },
    {
        label: 'Дороже',
        property: SortProperty.Price,
        direction: 'desc' as const
    },
    {
        label: 'По рейтингу',
        property: SortProperty.Rating,
        direction: 'desc' as const
    },
    {
        label: 'По наличию',
        property: SortProperty.Quantity,
        direction: 'desc' as const
    },
    {
        label: 'По сроку доставки',
        property: SortProperty.DeliveryDays,
        direction: 'asc' as const
    }
];

export const hasActiveSorting = (sortOptions: SortOption[]): boolean => {
    return sortOptions.some((option) => option.isActive);
};
